import React, {
  useState,
  useEffect
} from 'react';

import './loadPage.css';

function LoadPage() {

  return (
    <div className = "loadbody">
      <div>
        <p>l</p>
        <p>o</p>
        <p>a</p>
        <p>d</p>
        <p>i</p>
        <p>n</p>
        <p>g  </p>
        <p>j</p>
        <p>o</p>
        <p>b</p>
        <p>s</p>
      </div>
    </div>
  );
}

export default LoadPage;
